
const translation = {
  nav_used_pallets: "Kullanılmış Paletler",
  nav_new_pallets: "Yeni Paletler",
  nav_services: "Hizmetler",
  nav_about: "Hakkımızda",
  nav_faq: "SSS",
  nav_contact: "İletişim",
  nav_get_quote: "Teklif Al",

  hero_location: "Antwerp, Belçika",
  hero_title_line1: "PREMİUM",
  hero_title_line2: "EURO PALETLER",
  hero_subtitle: "A Sınıfı, B Sınıfı kullanılmış paletler ve yeni ahşap paletlerin güvenilir tedarikçisi. Kalite kontrollü. Belçika genelinde hızlı teslimat.",
  hero_cta_quote: "Teklif İste",
  hero_cta_products: "Ürünleri Gör",

  stat_years: "Yıl Deneyim",
  stat_pallets: "Teslim Edilen Palet",
  stat_grades: "Ürün Sınıfı",
  stat_quality: "Kalite Kontrollü",

  gallery_label: "Görebileceğiniz Kalite",
  gallery_title: "Palet Koleksiyonumuz",
  gallery_grade_a: "A Sınıfı Premium",
  gallery_grade_b: "B Sınıfı Ekonomik",
  gallery_new: "Yeni Paletler",
  gallery_custom: "Özel Siparişler",

  how_label: "Basit Süreç",
  how_title: "Nasıl Çalışır",
  how_subtitle: "Göz atmaktan teslimata kadar palet siparişini hızlı ve kolay hale getiriyoruz.",
  how_step1_title: "Gözat & Seç",
  how_step1_desc: "A Sınıfı, B Sınıfı ve yeni ahşap palet yelpazemizi keşfedin. Detaylı özellikleri ve fotoğrafları inceleyin.",
  how_step2_title: "Teklif İste / Sipariş Ver",
  how_step2_desc: "Teklif talebi gönderin veya doğrudan çevrimiçi sipariş verin. 24 saat içinde onaylıyoruz.",
  how_step3_title: "Hızlı Teslimat",
  how_step3_desc: "Paletlerinizi Belçika ve Avrupa genelinde hızlıca alın. Tüm siparişler sevkiyat öncesi kalite kontrolden geçer.",

  used_label: "Kaliteli Kullanılmış Paletler",
  used_title: "Kullanılmış Euro Paletler",
  used_subtitle: "A Sınıfı premium veya B Sınıfı ekonomik paletler arasından seçin. Tümü kontrol edilmiş ve hemen kullanıma hazır.",

  new_label: "Sıfır Yeni Paletler",
  new_title: "Yeni Ahşap Paletler",
  new_subtitle: "ISPM15 sertifikalı, ihracata hazır, en yüksek standartlarda üretilmiş paletler. Özel boyutlar mevcut.",

  product_quick_specs: "Hızlı Özellikler",
  product_dimensions: "Boyutlar",
  product_load: "Yük Kapasitesi",
  product_wood: "Ahşap Türü",
  product_order_now: "Şimdi Sipariş Ver",
  product_view_details: "Detayları Gör",
  product_view_angles: "Görünümler & Detaylar",
  product_tech_specs: "Teknik Özellikler",
  product_key_features: "Temel Özellikler",
  product_request_quote: "Bu Ürün İçin Teklif İste",
  product_call_us: "Bizi Ara",

  calc_current_price: "Mevcut Fiyat",
  calc_volume_hint: "Toplu fiyatlandırma mevcut – daha fazla sipariş verin, daha fazla tasarruf edin!",
  calc_total_price: "Toplam Fiyat",
  calc_price_per: "Palet başına fiyat",
  calc_quantity: "Miktar",
  calc_pallets: "palet",
  calc_order_now: "Sipariş Ver",
  calc_current_selection: "Mevcut Seçim",
  calc_pieces: "adet",
  calc_per_pallet: "palet başına",
  calc_calculate: "Siparişinizi Hesaplayın",
  calc_payment_methods: "MEVCUT ÖDEME YÖNTEMLERİ",
  calc_volume_pricing: "Toplu Fiyatlandırma",
  calc_bulk_discount: "Toplu indirim uygulandı",
  calc_min_order: "Minimum sipariş: 10 palet",
  calc_payment_methods_label: "Ödeme Yöntemleri:",
  calc_total: "Toplam:",
  calc_select_qty: "Miktar ve Ödeme Seçin",
  calc_total_price_label: "Toplam Fiyat",

  services_label: "Ne Yapıyoruz",
  services_title: "Hizmetlerimiz",
  services_subtitle: "Sıralamadan teslimata kadar işletmeniz için eksiksiz palet çözümleri sunuyoruz.",
  service1_title: "Palet Sıralama & Sınıflandırma",
  service1_desc: "Her paletin uzman manuel incelemesi ve sınıflandırması.",
  service2_title: "Toplu Tedarik",
  service2_desc: "Büyük miktarlı siparişler memnuniyetle karşılanır. Toplu alımlar için rekabetçi fiyatlar.",
  service3_title: "Özel Siparişler",
  service3_desc: "Standart dışı boyutlara mı ihtiyacınız var? Özel ahşap paletler üretiyoruz.",
  service4_title: "Hızlı Teslimat",
  service4_desc: "Belçika ve Avrupa genelinde güvenilir teslimat.",

  quality_label: "Standartlarımız",
  quality_title: "Kalite Sınıf Sistemi",
  quality_subtitle: "Tedarik ettiğimiz her palet, katı Avrupa standartlarına göre dikkatle incelenir ve sınıflandırılır.",
  grade_a_label: "Premium Sınıf",
  grade_b_label: "Standart Sınıf",
  grade_new_label: "Sıfır Yeni",

  about_label: "Biz Kimiz",
  about_title: "Antwerp'in Güvenilir Palet Ortağı",
  about_p1: "PEL Partner Company, Belçika'nın Antwerp şehrinde kurulu özel bir Euro palet tedarikçisidir. Belçika ve Avrupa genelindeki işletmelere yüksek kaliteli paletler tedarik ediyoruz.",
  about_p2: "İster hassas mallar için A Sınıfı premium paletlere, ister genel lojistik için ekonomik B Sınıfına, ister ihracat için sıfır paletlere ihtiyacınız olsun — doğru fiyata doğru çözümümüz var.",
  about_location: "Antwerp, Belçika",
  about_quality: "Her palet kontrol edildi",
  about_delivery: "Belçika genelinde hızlı",
  about_support: "Pzt–Cum 8:00–18:00",
  about_years: "Yıllık Deneyim",
  about_supplied: "Tedarik Edilen Palet",

  videos_label: "Çalışırken Görün",
  videos_title: "Operasyonlarımız",
  videos_subtitle: "Paletleri nasıl sıraladığımızı, incelediğimizi ve hazırladığımızı izleyin.",
  tab_sorting: "Sıralama Süreci",
  tab_quality: "Kalite Kontrolü",
  tab_delivery: "Teslimat",
  video_sorting_title: "Manuel Sıralama & İnceleme",
  video_sorting_desc: "Her palet kalite için elle kontrol edilir",
  video_strict: "Sıkı İnceleme",
  video_strict_desc: "Her palet, yapısal bütünlük ve EPAL uyumluluğu için manuel olarak incelenir.",
  video_sorted: "Sınıfa Göre Sıralandı",
  video_sorted_desc: "Paletler dikkatle A Sınıfı, B Sınıfı ve Yeni kategorilerine ayrılır.",
  video_reliable: "Güvenilir Teslimat",
  video_reliable_desc: "Antwerp ve Belçika genelinde hızlı teslimat süreleriyle dağıtım yapıyoruz.",

  why_title: "Neden PEL Partner'ı Seçmelisiniz?",
  why1_title: "Sertifikalı Kalite",
  why1_desc: "EPAL sertifikalı paletler, her parti Avrupa standartlarına göre incelendi.",
  why2_title: "Rekabetçi Fiyatlar",
  why2_desc: "Antwerp'te A, B Sınıfı ve yeni paletler için en iyi fiyatlar.",
  why3_title: "Hızlı Teslimat",
  why3_desc: "Hızlı sipariş işleme ve Belçika genelinde teslimat.",
  why4_title: "Güvenilir Ortak",
  why4_desc: "Güven, tutarlılık ve kalite üzerine kurulu uzun vadeli ilişkiler.",

  delivery_label: "Belçika Genelinde Teslimat Yapıyoruz",
  delivery_title: "Hizmet Bölgelerimiz",
  delivery_subtitle: "Belçika ve Avrupa genelindeki büyük şehirlere hızlı ve güvenilir palet teslimatı.",

  faq_label: "Sık Sorulan Sorular",
  faq_title: "Sıkça Sorulan Sorular",
  faq_subtitle: "Paletlerimiz, hizmetlerimiz ve sipariş süreci hakkında en sık sorulan soruların yanıtlarını bulun.",
  faq_q1: "Hangi palet sınıflarını sunuyorsunuz?",
  faq_a1: "Üç sınıf sunuyoruz: A Sınıfı (mükemmel durumda premium kullanılmış paletler), B Sınıfı (hafif aşınmalı ekonomik kullanılmış paletler) ve Yeni Ahşap Paletler (sıfır, ihracat için ISPM15 sertifikalı).",
  faq_q2: "Minimum sipariş miktarı nedir?",
  faq_a2: "Küçük miktarlardan büyük siparişlere kadar her boyutta siparişi karşılıyoruz. Özel gereksinimlerinizi görüşmek için bize ulaşın.",
  faq_q3: "Hangi bölgelere teslimat yapıyorsunuz?",
  faq_a3: "Antwerp, Brüksel, Gent, Bruges ve Liège dahil Belçika genelinde teslimat yapıyoruz. Avrupa genelinde de müşterilere hizmet veriyoruz.",
  faq_q4: "Teslimat süreleriniz nedir?",
  faq_a4: "A ve B Sınıfı kullanılmış paletler genellikle stokta bulunur ve hemen teslim edilebilir. Yeni ahşap paletler miktara bağlı olarak 1-2 hafta gerektirebilir.",
  faq_q5: "Paletleriniz EPAL sertifikalı mı?",
  faq_a5: "Evet, A Sınıfı paletlerimiz EPAL sertifikalı ve damgalıdır. Tüm yeni ahşap paletler ISPM15 ısıl işlem görmüş ve damgalanmıştır.",
  faq_q6: "Özel palet boyutları sunuyor musunuz?",
  faq_a6: "Evet, özel boyutlarda yeni ahşap paletler üretebiliriz. Standart EUR/EPAL boyutu 1200 × 800 mm'dir.",
  faq_q7: "Palet kalitesini nasıl sağlıyorsunuz?",
  faq_a7: "Tedarik ettiğimiz her palet, eğitimli personelimiz tarafından manuel olarak incelenir. Yapısal bütünlük ve EPAL uyumluluğunu kontrol ediyoruz.",
  faq_q8: "Hangi ödeme yöntemlerini kabul ediyorsunuz?",
  faq_a8: "Banka havalesi, kredi kartı kabul ediyoruz ve köklü iş müşterileri için ödeme koşulları düzenleyebiliriz.",

  contact_label: "Ulaşın",
  contact_title: "İletişime Geçin",
  contact_info_title: "İletişim Bilgileri",
  contact_phone_label: "Telefon",
  contact_email_label: "E-posta",
  contact_location_label: "Konum",
  contact_hours_label: "Çalışma Saatleri",
  contact_hours_val: "Pazartesi – Cuma: 8:00 – 18:00",
  contact_call_now: "Şimdi Ara",
  contact_email_us: "E-posta Gönder",
  contact_quote_title: "Teklif İste",
  form_name: "Ad",
  form_phone: "Telefon",
  form_email: "E-posta",
  form_product: "Ürün",
  form_product_placeholder: "Ürün seçin...",
  form_product_a: "Kullanılmış Euro Paletler — A Sınıfı",
  form_product_b: "Kullanılmış Euro Paletler — B Sınıfı",
  form_product_new: "Yeni Ahşap Paletler",
  form_product_mixed: "Karma Sipariş",
  form_message: "Mesaj",
  form_message_placeholder: "Gereksinimlerinizi, ihtiyaç duyduğunuz miktarı bize anlatın...",
  form_send: "Talep Gönder",
  form_sending: "Gönderiliyor...",
  form_success_title: "Mesaj Gönderildi!",
  form_success_desc: "En kısa sürede size geri döneceğiz.",
  form_send_another: "Başka Gönder",
  form_error: "Bir şeyler ters gitti. Lütfen tekrar deneyin.",

  order_title: "Siparişinizi Verin",
  order_subtitle: "Bilgilerinizi doldurun, siparişinizi 24 saat içinde onaylayacağız.",
  order_company: "Şirket Adı",
  order_company_ph: "Şirketinizin adı",
  order_contact: "İletişim Adı",
  order_contact_ph: "Tam adınız",
  order_quantity: "Miktar",
  order_quantity_ph: "Palet sayısı",
  order_address: "Teslimat Adresi",
  order_address_ph: "Sokak, Şehir, Posta Kodu",
  order_date: "Tercih Edilen Teslimat Tarihi",
  order_notes: "Ek Notlar",
  order_notes_ph: "Özel gereksinimler veya sorular...",
  order_cancel: "İptal",
  order_review: "Siparişi İncele",
  order_summary_title: "Sipariş Özeti",
  order_summary_subtitle: "Göndermeden önce lütfen sipariş detaylarınızı inceleyin.",
  order_company_info: "Şirket Bilgileri",
  order_company_name_label: "Şirket Adı",
  order_contact_label: "İletişim Kişisi",
  order_email_label: "E-posta",
  order_phone_label: "Telefon",
  order_details: "Sipariş Detayları",
  order_product_label: "Ürün",
  order_qty_label: "Miktar",
  order_qty_unit: "palet",
  order_address_label: "Teslimat Adresi",
  order_date_label: "Tercih Edilen Tarih",
  order_notes_label: "Ek Notlar",
  order_next_steps: "Sonraki Adımlar:",
  order_next_steps_desc: "Siparişinizi gönderdikten sonra ekibimiz inceleyecek ve fiyatlandırma, stok durumu ve teslimat detaylarını onaylamak için 24 saat içinde sizinle iletişime geçecektir.",
  order_edit: "Siparişi Düzenle",
  order_confirm: "Onayla & Gönder",
  order_submitting: "Siparişiniz Gönderiliyor...",
  order_submitting_desc: "Lütfen bir dakika bekleyin.",
  order_success_title: "Sipariş Başarıyla Gönderildi!",
  order_ref_label: "Referans Numarası",
  order_success_desc: "Siparişiniz için teşekkürler! Talebinizi inceleyecek ve fiyatlandırma, stok ve teslimat detaylarını onaylamak için 24 saat içinde sizinle iletişime geçeceğiz.",
  order_close: "Kapat",
  order_error: "Bir şeyler ters gitti. Lütfen tekrar deneyin.",

  footer_products: "Ürünler",
  footer_contact: "İletişim",
  footer_copyright: "© 2025 PEL Partner Company. Tüm hakları saklıdır.",
  footer_tagline: "Antwerp, Belçika — Euro Palet Tedarikçisi",
  footer_desc: "Antwerp, Belçika'daki güvenilir Euro palet tedarikçiniz. A, B Sınıfı ve yeni ahşap paletler — kalite garantili.",

  compare_label: "Karşılaştırma",
  compare_title: "Palet Sınıflarımızı Karşılaştırın",
  compare_subtitle: "Hangi sınıfın size uygun olduğundan emin değil misiniz? Üç seçeneği tek bakışta karşılaştırın.",
  compare_feature: "Özellik",
  compare_grade_a: "A Sınıfı",
  compare_grade_b: "B Sınıfı",
  compare_new: "Yeni Paletler",
  compare_condition: "Durum",
  compare_condition_a: "Mükemmel — minimum aşınma",
  compare_condition_b: "İyi — hafif kozmetik aşınma",
  compare_condition_new: "Sıfır — kullanılmamış",
  compare_certification: "Sertifikasyon",
  compare_certification_a: "EPAL Sertifikalı",
  compare_certification_b: "Kalite Kontrollü",
  compare_certification_new: "ISPM15 Sertifikalı",
  compare_load: "Yük Kapasitesi",
  compare_load_a: "1500 kg'a kadar",
  compare_load_b: "1000 kg'a kadar",
  compare_load_new: "2000 kg'a kadar",
  compare_export: "İhracata Hazır",
  compare_export_a: "Yalnızca AB",
  compare_export_b: "Yalnızca AB",
  compare_export_new: "Dünya Geneli",
  compare_custom: "Özel Boyutlar",
  compare_custom_a: "Hayır",
  compare_custom_b: "Hayır",
  compare_custom_new: "Evet",
  compare_availability: "Stok Durumu",
  compare_availability_a: "Stokta Mevcut",
  compare_availability_b: "Stokta Mevcut",
  compare_availability_new: "Siparişe Göre",
  compare_best_for: "En Uygun Kullanım",
  compare_best_for_a: "Gıda, hassas mallar",
  compare_best_for_b: "Genel depolama",
  compare_best_for_new: "İhracat & uluslararası nakliye",
  compare_starting_price: "Başlangıç Fiyatı",
  compare_cta: "Şimdi Sipariş Ver",
  compare_yes: "Evet",
  compare_no: "Hayır",
};

export default translation;
